export default __webpack_public_path__ + "static/media/picture.02e37f96.ogg";